import React from 'react';
import {
  useSocketConfig,
  stoneByOtherId,
  stoneImageUrl,
  stoneDisplayName,
  effectLabel,
  computeSocketBonuses,
  isEnglish,
} from '../../utils/socketConfig';
import './Sockets.css';

// Eşya üzerindeki soketleri (dolu/boş), taş bonuslarını ve aktif kombinasyonları gösterir.
const SocketSlots = ({ item, compact = false, selectedIndex = null, onSelectSocket = null }) => {
  const cfg = useSocketConfig();
  const count = item?.socketCount || 0;
  if (!count) return null;
  const slots = Array.from({ length: count }, (_, i) => item?.sockets?.[i] || 0);
  const en = isEnglish();
  const { rows, combos } = cfg ? computeSocketBonuses(cfg, slots) : { rows: [], combos: [] };

  return (
    <div className={`socket-box${compact ? ' socket-box--compact' : ''}`}>
      <div className="socket-box-title">💎 {en ? 'Sockets' : 'Soketler'} ({slots.filter(Boolean).length}/{count})</div>
      <div className="socket-row">
        {slots.map((id, i) => {
          const found = stoneByOtherId(cfg, id);
          const clickable = !!onSelectSocket && !id;
          return (
            <button
              key={i}
              type="button"
              className={`socket-hole${id ? ' socket-hole--filled' : ''}${selectedIndex === i ? ' socket-hole--selected' : ''}`}
              onClick={clickable ? () => onSelectSocket(i) : undefined}
              disabled={!clickable}
              title={found ? stoneDisplayName(cfg, found.stone, found.level) : en ? 'Empty socket' : 'Boş soket'}
            >
              {found ? <img src={stoneImageUrl(found.stone, found.level)} alt="" /> : null}
            </button>
          );
        })}
      </div>
      {!compact && rows.map((r, i) => (
        <p key={`sr-${i}`} className="socket-bonus-row">
          {effectLabel(cfg, r.effect)}: <span className="socket-bonus-val">+{r.value}</span>
        </p>
      ))}
      {combos.map((c) => (
        <div key={c.key} className="socket-combo">
          <strong>✨ {en ? c.nameEn : c.name}</strong>
          {!compact && (
            <span>
              {c.bonuses.map((b) => `${effectLabel(cfg, b.type)} +${b.value}`).join(' · ')}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default SocketSlots;
